import { JSX } from 'react';
import { IGroupExamsSchedule } from 'entities/types';
import { GroupExamsRowTableSchedule } from 'widgets/schedule/stageExamsTableSchedule/rowTableSchedule';

export const makeRows = (data: IGroupExamsSchedule[]) => {
  const rows: JSX.Element[] = [];
  data.forEach((item) => {
    rows.push(
      <GroupExamsRowTableSchedule
        data={item}
        key={item.examdate + item.disciplname + item.examtime}
      />,
    );
  });

  if (data.length === 0) {
    rows.push(
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          paddingTop: '27px',
          color: 'var(--black-light-26)',
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        Нет результатов
      </div>,
    );
  }

  return rows;
};
